<template>
  <div class="user-list">
    <el-tabs v-model="status" type="card" @tab-click="getList">
      <el-tab-pane label="正常" name="1"></el-tab-pane>
      <el-tab-pane label="黑名单" name="2"></el-tab-pane>
    </el-tabs>
    <div class="search-bar flex">
      <div class="left" style="display: flex; align-items: center">
        <!-- <el-select v-model="searchParam.userType" placeholder="用户类型" clearable>
                    <el-option value="1" label="普通用户"></el-option>
                    <el-option value="2" label="付费用户"></el-option>
                </el-select> -->

        <el-input v-model="searchParam.search_value" placeholder="请输入关键词搜索">
          <el-select slot="prepend" v-model="search_type" placeholder="id" style="width: 100px">
            <el-option value="title" label="分校名称"></el-option>
            <el-option value="name" label="昵称"></el-option>
            <el-option value="phone" label="手机号"></el-option>
          </el-select>
        </el-input>
        <el-date-picker
          v-model="dates"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="getDates"
        >
        </el-date-picker>
        <el-button type="primary" @click="getList('clear')">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </div>
      <div class="right">
        <el-button @click="exportData">导出查询结果</el-button>
        <el-button v-if="isschool" type="primary" @click="addStudent">新增分校</el-button>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="school_id" label="分校id"> </el-table-column>
        <el-table-column prop="title" label="分校名称"> </el-table-column>
        <el-table-column prop="address" label="地区">
          <template slot-scope="scope">
            {{ getAreaName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="分校长姓名"> </el-table-column>
        <el-table-column prop="phone" label="分校长手机号"> </el-table-column>

        <el-table-column prop="count_course" label="课程数量"> </el-table-column>
        <el-table-column prop="teacher_count" label="老师数量"> </el-table-column>
        <el-table-column prop="create_time" label="注册时间"> </el-table-column>
        <el-table-column width="150px" label="操作">
          <template slot-scope="scope">
            <el-button v-if="isschool" class="mid-blue" @click="toDetail(scope.row)">查看</el-button>
            <el-button v-if="status == 1" class="mid-red" @click="deleteItem(scope.row)">封禁</el-button>
            <el-button v-else class="mid-red" @click="deleteItem(scope.row)">解禁</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getSchoolList, disableSchool, exportSchool } from "@/api/school.js";
import { mixin } from "@/mixins/pagination.js";
import { getAreaLists } from "@/api/common.js";
import Utils from "@/jslibs/utils";
export default {
  mixins: [mixin],
  data() {
    return {
      dates: [],
      areaList: [],
      loading: false,
      status: "1",
      skey: "uuid",
      search_type: "title",
      searchParam: {},
      tableData: [],
    };
  },
  computed: {
    isschool() {
      const g = Utils.getCookie("X-Access-Group");
      return g != 928;
    },
  },
  async mounted() {
    await this.getArea();
    this.getList();
  },
  methods: {
    getAreaName(row) {
      const arr = [row.province_id, row.area_id, row.city_id];
      let i1 = {};
      let i2 = {};
      let i3 = {};
      let str = "";
      i1 = this.areaList.find((item) => {
        return item.area_id == row.province_id;
      });
      if (i1 && i1.child instanceof Array) {
        str = i1.area_name;
        i2 = i1.child.find((item) => {
          return item.area_id == row.area_id;
        });
      }
      if (i2 && i2.child instanceof Array) {
        str += i2.area_name;
        i3 = i2.child.find((item) => {
          return item.area_id == row.city_id;
        });
      }
      if (i3) {
        str += i3.area_name;
      }
      return str + row.address;
    },
    getArea() {
      return getAreaLists().then((res) => {
        console.log(res);
        if (res instanceof Array) {
          this.areaList = res;
        }
      });
    },
    getDates(val) {
      console.log(val);
      if (Array.isArray(val)) {
        this.searchParam.start_time = val[0];
        this.searchParam.end_time = val[1];
      }
    },
    resetSearch() {
      this.dates = [];
      this.searchParam = {};
      this.getList();
    },
    addStudent() {
      this.$router.push({ path: "/school-add" });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({ path: "/school-add", query: row });
    },
    exportData() {
      const param = {
        ...this.searchParam,
        page_size: this.page_size,
        page_index: this.page_index,
        status: this.status,
      };
      if (param.search_value) {
        param.search_type = this.search_type;
      }
      exportSchool(param);
    },
    async getList(type) {
      if (type == "clear") {
        this.page_index = 1;
      }

      const param = {
        ...this.searchParam,
        page_size: this.page_size,
        page_index: this.page_index,
        status: this.status,
      };
      if (param.search_value) {
        param.search_type = this.search_type;
      }
      // param[this.skey] = this.searchParam.keyword_search
      this.loading = true;
      const res = await getSchoolList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      } else {
        this.tableData = [];
        this.total = 0;
      }
      console.log(res);
    },
    deleteItem(row) {
      this.$confirm("确定要" + (this.status == 1 ? "封禁" : "解禁") + "该分校吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          disableSchool(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
